module.exports = __webpack_public_path__ + "_assets/img/pJko.149288c0.svg";